import serverRequestUtil from '../utils/ServerRequestUtil';

export default new class {
    constructor() {}

    getHecBalance() {
        return serverRequestUtil.get('/api/app/membership/balance');
    }

    agreement() {
        return serverRequestUtil.post('api/app/membership/agreement');
    }

    payment(amount) {
        return serverRequestUtil.post('api/app/membership/payment', { amount });
    }

    async setCompleteAtCampaign() {
        return serverRequestUtil.get('/api/app/aube-coin/campaign-completed');
    }

    // Smart Pool 権利による無料契約
    async setCompleteAtSmartPool() {
        return serverRequestUtil.post('/api/app/aube-coin/smart-pool-completed');
    }

    // ユーザパターンを設定 ("Pattern B (New)" としてマーク; すでに Pattern A が設定されている場合は上書きしない)
    async patternsSetAs() {
        return serverRequestUtil.put('/api/app/aube-coin/patterns-set-as');
    }
}
